module.exports = __webpack_public_path__ + "img/intelligent_risk_control.b7ead638.png";